export class ProductionInform {
    constructor({
                    id = null,
                    // code = ``,
                    day = ``,
                    title = '',
                    editor = '',
                    content = '',
                } = {}) {
        this.id = id;
        // this.code = code;
        this.day = day;
        this.title = title;
        this.editor = editor;
        this.content = content;
    }
}

export function gridFields() {
    return Object.freeze([
        // {
        //     key: 'code',
        //     label: 'lbl.productionInform.code',
        //     sortable: true,
        //     form: {
        //         type: 'input'
        //     }
        // },
        {
            key: 'day',
            label: 'lbl.productionInform.day',
            sortable: true,
            form: {
                type: 'datepicker'
            }
        },
        {
            key: 'title',
            label: 'lbl.productionInform.title',
            sortable: true,
            form: {
                type: 'a'
            }
        },
        {
            key: 'editor',
            label: 'lbl.productionInform.editor',
            sortable: true,
            form: {
                type: 'input'
            }
        }
    ])
}

export const fields = Object.freeze(Object.keys(new ProductionInform()).map(i => 'entity.' + i));

export const filterFields = [
    'filter.codeFilter',
    'filter.startDayFilter',
    'filter.endDayFilter',
    'filter.titleFilter',
    'filter.editorFilter'
];

export const filter = {
    'codeFilter': "",
    'startDayFilter': "",
    'endDayFilter': "",
    'titleFilter': "",
    'editorFilter': ""
};
